module.exports = __webpack_public_path__ + "img/e6215a53b78c8765147ee42956aa8fac.jpg";